import React from 'react';
import ContentLoader from 'react-content-loader';

/**
 * Row-shaped skeleton that mirrors the CacheRecentRow grid: kind badge,
 * title bar, time chip. Color tokens match the existing LoaderTable family
 * in components/loaders so the dropdown skeleton feels native to the app.
 */
const CacheRecentSkeletonRow = ({ widthScale }: { widthScale: number }) => (
  <ContentLoader
    height={32}
    width={420}
    speed={2}
    primaryColor="#E2E5E8"
    secondaryColor="#D3D7DC"
    style={{ width: '100%', height: 32 }}
  >
    <rect x="8" y="8" rx="3" ry="3" width="74" height="18" />
    <rect x="92" y="11" rx="4" ry="4" width={240 * widthScale} height="12" />
    <rect x="354" y="12" rx="3" ry="3" width="58" height="10" />
  </ContentLoader>
);

interface Props {
  rows?: number;
}

const CacheRecentSkeleton = ({ rows = 4 }: Props) => {
  const scales = [0.95, 0.78, 0.88, 0.7, 0.92, 0.74];
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <CacheRecentSkeletonRow key={i} widthScale={scales[i % scales.length]} />
      ))}
    </>
  );
};

export default CacheRecentSkeleton;
